import React from "react"

// Cloudflare Turnstile widget. It injects a hidden input named
// "cf-turnstile-response" into the surrounding form, so TargetForm picks it up.
// The site key is public, the fallback keeps builds without .env working.
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAFihZVgBCNcqPhDY"

declare global {
    interface Window {
        turnstile?: any
    }
}

const resetCaptcha = () => {
    try {
        window.turnstile?.reset()
    } catch(e){
        console.log('captcha reset error', e)
    }
}

class LCaptcha extends React.Component {
    private _container = React.createRef<HTMLDivElement>()
    private _widgetId: string | null = null
    private _timer: any = null

    componentDidMount(){
        this.renderWidget()
    }

    componentWillUnmount(){
        clearTimeout(this._timer)
        if(this._widgetId !== null){
            try {
                window.turnstile?.remove(this._widgetId)
            } catch(e){}
            this._widgetId = null
        }
    }

    renderWidget = () => {
        // The api script loads async, wait until it is available
        if(!window.turnstile){
            this._timer = setTimeout(this.renderWidget, 200)
            return
        }
        if(this._container.current && this._widgetId === null){
            try {
                this._widgetId = window.turnstile.render(this._container.current, {
                    sitekey: SITE_KEY,
                    theme: "light",
                    size: "flexible",
                    // Stays invisible unless Cloudflare needs the visitor to click
                    appearance: "interaction-only",
                })
            } catch(e){
                console.log('captcha render error', e)
            }
        }
    }

    render(){
        return <div className="captcha-pref" ref={this._container}/>
    }
}

export { LCaptcha, resetCaptcha }
